import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FiberManualRecord as CircleIcon } from '@mui/icons-material';
import { Chip, Typography } from '@mui/material';

dayjs.extend(relativeTime);

type LastConnectedProps = {
    timestamp: string | null | undefined;
};

// ? The number of milliseconds after which the dot should be red
const THRESHOLD = 60_000 * 60;

export const LastConnected = ({ timestamp }: LastConnectedProps) => {
    const difference = timestamp ? Date.now() - new Date(timestamp).getTime() : null;
    const text = difference ? dayjs().to(timestamp) : 'Unknown';

    return (
        <Chip
            label={text}
            size='small'
            icon={
                <CircleIcon
                    fontSize='small'
                    sx={{
                        color: difference
                            ? difference >= THRESHOLD
                                ? 'red !important'
                                : 'green !important'
                            : 'grey !important',
                    }}
                />
            }
            sx={{
                display: 'flex',
                alignItems: 'center',
            }}
        />
    );
};
